module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_1.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_1.body)
    }
  })]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "router": "",
      "to": {
        path: '/donate/1'
      }
    }
  }, [_vm._v(_vm._s(_vm.content.section_1.button_text))])], 1)])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('div', {
    staticClass: "featured_block"
  }, [_c('div', {
    staticClass: "featured_block__image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/love-life.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("LoveLife")])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('div', {
    staticClass: "featured_block"
  }, [_c('div', {
    staticClass: "featured_block__image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/spec-savers.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Spec Savers")])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('div', {
    staticClass: "featured_block"
  }, [_c('div', {
    staticClass: "featured_block__image"
  }), _vm._v(" "), _c('p', [_vm._v("Department of Education")])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('div', {
    staticClass: "featured_block"
  }, [_c('div', {
    staticClass: "featured_block__image"
  }), _vm._v(" "), _c('p', [_vm._v("Health and Social Development")])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('div', {
    staticClass: "featured_block"
  }, [_c('div', {
    staticClass: "featured_block__image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/afda.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Afda")])])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-panel', {
    attrs: {
      "black": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md5": ""
    }
  }, [_c('div', {
    staticClass: "featured-info"
  }, [_c('h6', [_vm._v("Read more about ster-kinekor")]), _vm._v(" "), _c('p', [_vm._v("Stay on top of all the latest updates from Ster-kinekor and be the ﬁrst to know about future CSI initiatives")])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "md1": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md5": ""
    }
  }, [_c('div', {
    staticClass: "featured-button"
  }, [_c('sk-button', {
    attrs: {
      "tag": "a",
      "primary": "",
      "href": "/news"
    }
  }, [_vm._v("View SK News")])], 1)])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5949672c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vision-mission/partners/partners.vue
// module id = 809
// module chunks = 0